export default `:host {
  display: block;
  width: 100%;
  box-sizing: border-box;
  grid-column: 1/-1;
  --ids-form-layout-inline-field-height: var(--ids-input-height-30);
}

:host([field-height=xs]) {
  --ids-form-layout-inline-field-height: var(--ids-input-height-10);
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([field-height=sm]) {
  --ids-form-layout-inline-field-height: var(--ids-input-height-20);
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
}

:host([field-height=md]) {
  --ids-form-layout-inline-field-height: var(--ids-input-height-30);
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
}

:host([field-height=lg]) {
  --ids-form-layout-inline-field-height: var(--ids-input-height-40);
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
}

:host([compact]) {
  --ids-form-layout-inline-field-height: var(--ids-input-height-10);
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([hidden]) {
  display: none;
}

.ids-form-layout-inline {
  display: grid;
  gap: var(--ids-form-layout-inline-row-gap, var(--ids-space-2xs));
  width: 100%;
  align-items: start;
}

.ids-form-layout-inline-label {
  display: flex;
  align-items: center;
  color: var(--ids-input-label-color-text-default);
  font-size: var(--ids-input-label-font-size);
  line-height: var(--ids-input-label-line-height);
  min-width: 0;
  min-height: var(--ids-form-layout-inline-field-height);
}

.ids-form-layout-inline-required {
  color: var(--ids-input-required-indicator-color, var(--ids-color-error-default));
  margin-inline-start: var(--ids-space-3xs);
}

.ids-form-layout-inline-content {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  gap: var(--ids-space-sm);
  min-width: 0;
}

::slotted(*) {
  min-width: 0;
}

.ids-form-layout-inline-validation:empty {
  display: none;
}
.ids-form-layout-inline-validation .validation-message {
  display: flex;
  align-items: center;
  gap: var(--ids-space-3xs);
  margin-block-start: var(--ids-space-2xs);
  color: var(--ids-input-error-color-text-default, var(--ids-color-error-default));
}
.ids-form-layout-inline-validation .validation-message .ids-icon {
  color: var(--ids-input-error-color-text-default, var(--ids-color-error-default));
  flex-shrink: 0;
}

::slotted(ids-checkbox),
::slotted(ids-radio),
::slotted(ids-radio-group),
::slotted(ids-switch),
::slotted(ids-hyperlink),
::slotted(ids-text),
::slotted(ids-button) {
  display: inline-flex;
  align-items: center;
  min-height: var(--ids-form-layout-inline-field-height);
}

::slotted(ids-input),
::slotted(ids-dropdown),
::slotted(ids-datepicker),
::slotted(ids-timepicker) {
  flex: 1;
  min-width: 0;
}
@media (width <= 320px) {
  ::slotted(ids-input),
  ::slotted(ids-dropdown),
  ::slotted(ids-datepicker),
  ::slotted(ids-timepicker) {
    flex: 100%;
  }
}

:host([label-position=inline-start]) .ids-form-layout-inline {
  grid-template-columns: var(--ids-form-layout-label-width, 140px) minmax(0, 1fr);
  align-items: start;
  column-gap: var(--ids-space-xs);
  row-gap: 0;
}

:host([label-position=inline-start]) .ids-form-layout-inline-label {
  align-self: center;
}

:host([label-position=inline-start]) .ids-form-layout-inline-validation {
  grid-column: 2;
}

:host([label-position=inline-end]) .ids-form-layout-inline-validation {
  grid-column: 1;
}

:host([label-position=inline-end]) .ids-form-layout-inline {
  grid-template-columns: minmax(0, 1fr) var(--ids-form-layout-label-width, 140px);
  align-items: center;
  column-gap: var(--ids-form-layout-inline-col-gap, var(--ids-form-layout-inline-gap, var(--ids-space-sm)));
  row-gap: 0;
}

:host([label-position=inline-end]) .ids-form-layout-inline-label {
  order: 2;
  align-self: center;
}

:host([label-position=inline-end]) .ids-form-layout-inline-content {
  order: 1;
}

:host([label-alignment=end]) .ids-form-layout-inline-label {
  text-align: end;
  justify-content: flex-end;
}

:host([label-alignment=start]) .ids-form-layout-inline-label {
  text-align: start;
  justify-content: flex-start;
}

:host([label-wrap=ellipsis]) .ids-form-layout-inline-label,
:host([label-wrap=ellipsis-no-stretch]) .ids-form-layout-inline-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([label-wrap=wrap]) .ids-form-layout-inline-label,
:host([label-wrap=wrap-no-stretch]) .ids-form-layout-inline-label {
  white-space: normal;
  overflow-wrap: break-word;
}

:host([label-state=hidden]) .ids-form-layout-inline-label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

:host([label-state=collapsed]) .ids-form-layout-inline-label {
  display: none;
}

:host([label-position=inline-start][label-state=hidden]) .ids-form-layout-inline,
:host([label-position=inline-start][label-state=collapsed]) .ids-form-layout-inline,
:host([label-position=inline-end][label-state=hidden]) .ids-form-layout-inline,
:host([label-position=inline-end][label-state=collapsed]) .ids-form-layout-inline {
  grid-template-columns: minmax(0, 1fr);
}

@media (width <= 320px) {
  :host(:not([enable-container])[label-position=inline-start]) .ids-form-layout-inline,
  :host(:not([enable-container])[label-position=inline-end]) .ids-form-layout-inline {
    grid-template-columns: minmax(0, 1fr);
    align-items: start;
    row-gap: var(--ids-form-layout-inline-row-gap, var(--ids-space-2xs));
  }
  :host(:not([enable-container])[label-position=inline-end]) .ids-form-layout-inline-label {
    order: 0;
  }
  :host(:not([enable-container])[label-position=inline-end]) .ids-form-layout-inline-content {
    order: 0;
  }
  :host(:not([enable-container])[label-position=inline-start]) .ids-form-layout-inline-label,
  :host(:not([enable-container])[label-position=inline-end]) .ids-form-layout-inline-label {
    align-self: start;
    text-align: start;
    justify-content: flex-start;
  }
}
@container (width <= 320px) {
  :host([enable-container][label-position=inline-start]) .ids-form-layout-inline,
  :host([enable-container][label-position=inline-end]) .ids-form-layout-inline {
    grid-template-columns: minmax(0, 1fr);
    align-items: start;
    row-gap: var(--ids-form-layout-inline-row-gap, var(--ids-space-2xs));
  }
  :host([enable-container][label-position=inline-end]) .ids-form-layout-inline-label {
    order: 0;
  }
  :host([enable-container][label-position=inline-end]) .ids-form-layout-inline-content {
    order: 0;
  }
  :host([enable-container][label-position=inline-start]) .ids-form-layout-inline-label,
  :host([enable-container][label-position=inline-end]) .ids-form-layout-inline-label {
    align-self: start;
    text-align: start;
    justify-content: flex-start;
  }
}
:host([wrap=false]) .ids-form-layout-inline-content {
  flex-wrap: nowrap;
}

:host([gap=none]) {
  --ids-form-layout-inline-gap: 0;
}

:host([gap="2xs"]) {
  --ids-form-layout-inline-gap: var(--ids-space-2xs);
}

:host([gap=xs]) {
  --ids-form-layout-inline-gap: var(--ids-space-xs);
}

:host([gap=sm]) {
  --ids-form-layout-inline-gap: var(--ids-space-sm);
}

:host([gap=md]) {
  --ids-form-layout-inline-gap: var(--ids-space-md);
}

:host([gap=lg]) {
  --ids-form-layout-inline-gap: var(--ids-space-lg);
}

:host([gap=xl]) {
  --ids-form-layout-inline-gap: var(--ids-space-xl);
}

:host([gap]) .ids-form-layout-inline-content {
  gap: var(--ids-form-layout-inline-gap);
}

:host([columns="1"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

:host([columns="2"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

:host([columns="3"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

:host([columns="4"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

:host([columns="5"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

:host([columns="6"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

:host([columns="7"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

:host([columns="8"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

:host([columns="9"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

:host([columns="10"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

:host([columns="11"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

:host([columns="12"]) .ids-form-layout-inline-content {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

:host([col-span="1"]) {
  grid-column: span 1;
}

:host([col-span="2"]) {
  grid-column: span 2;
}

:host([col-span="3"]) {
  grid-column: span 3;
}

:host([col-span="4"]) {
  grid-column: span 4;
}

:host([col-span="5"]) {
  grid-column: span 5;
}

:host([col-span="6"]) {
  grid-column: span 6;
}

:host([col-span="7"]) {
  grid-column: span 7;
}

:host([col-span="8"]) {
  grid-column: span 8;
}

:host([col-span="9"]) {
  grid-column: span 9;
}

:host([col-span="10"]) {
  grid-column: span 10;
}

:host([col-span="11"]) {
  grid-column: span 11;
}

:host([col-span="12"]) {
  grid-column: span 12;
}

@media (width >= 0) {
  :host([col-span-xs="1"]) {
    grid-column: span 1;
  }
  :host([col-span-xs="2"]) {
    grid-column: span 2;
  }
  :host([col-span-xs="3"]) {
    grid-column: span 3;
  }
  :host([col-span-xs="4"]) {
    grid-column: span 4;
  }
  :host([col-span-xs="5"]) {
    grid-column: span 5;
  }
  :host([col-span-xs="6"]) {
    grid-column: span 6;
  }
  :host([col-span-xs="7"]) {
    grid-column: span 7;
  }
  :host([col-span-xs="8"]) {
    grid-column: span 8;
  }
  :host([col-span-xs="9"]) {
    grid-column: span 9;
  }
  :host([col-span-xs="10"]) {
    grid-column: span 10;
  }
  :host([col-span-xs="11"]) {
    grid-column: span 11;
  }
  :host([col-span-xs="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 767px) {
  :host([col-span-sm="1"]) {
    grid-column: span 1;
  }
  :host([col-span-sm="2"]) {
    grid-column: span 2;
  }
  :host([col-span-sm="3"]) {
    grid-column: span 3;
  }
  :host([col-span-sm="4"]) {
    grid-column: span 4;
  }
  :host([col-span-sm="5"]) {
    grid-column: span 5;
  }
  :host([col-span-sm="6"]) {
    grid-column: span 6;
  }
  :host([col-span-sm="7"]) {
    grid-column: span 7;
  }
  :host([col-span-sm="8"]) {
    grid-column: span 8;
  }
  :host([col-span-sm="9"]) {
    grid-column: span 9;
  }
  :host([col-span-sm="10"]) {
    grid-column: span 10;
  }
  :host([col-span-sm="11"]) {
    grid-column: span 11;
  }
  :host([col-span-sm="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 927px) {
  :host([col-span-md="1"]) {
    grid-column: span 1;
  }
  :host([col-span-md="2"]) {
    grid-column: span 2;
  }
  :host([col-span-md="3"]) {
    grid-column: span 3;
  }
  :host([col-span-md="4"]) {
    grid-column: span 4;
  }
  :host([col-span-md="5"]) {
    grid-column: span 5;
  }
  :host([col-span-md="6"]) {
    grid-column: span 6;
  }
  :host([col-span-md="7"]) {
    grid-column: span 7;
  }
  :host([col-span-md="8"]) {
    grid-column: span 8;
  }
  :host([col-span-md="9"]) {
    grid-column: span 9;
  }
  :host([col-span-md="10"]) {
    grid-column: span 10;
  }
  :host([col-span-md="11"]) {
    grid-column: span 11;
  }
  :host([col-span-md="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 928px) {
  :host([col-span-lg="1"]) {
    grid-column: span 1;
  }
  :host([col-span-lg="2"]) {
    grid-column: span 2;
  }
  :host([col-span-lg="3"]) {
    grid-column: span 3;
  }
  :host([col-span-lg="4"]) {
    grid-column: span 4;
  }
  :host([col-span-lg="5"]) {
    grid-column: span 5;
  }
  :host([col-span-lg="6"]) {
    grid-column: span 6;
  }
  :host([col-span-lg="7"]) {
    grid-column: span 7;
  }
  :host([col-span-lg="8"]) {
    grid-column: span 8;
  }
  :host([col-span-lg="9"]) {
    grid-column: span 9;
  }
  :host([col-span-lg="10"]) {
    grid-column: span 10;
  }
  :host([col-span-lg="11"]) {
    grid-column: span 11;
  }
  :host([col-span-lg="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 1183px) {
  :host([col-span-xl="1"]) {
    grid-column: span 1;
  }
  :host([col-span-xl="2"]) {
    grid-column: span 2;
  }
  :host([col-span-xl="3"]) {
    grid-column: span 3;
  }
  :host([col-span-xl="4"]) {
    grid-column: span 4;
  }
  :host([col-span-xl="5"]) {
    grid-column: span 5;
  }
  :host([col-span-xl="6"]) {
    grid-column: span 6;
  }
  :host([col-span-xl="7"]) {
    grid-column: span 7;
  }
  :host([col-span-xl="8"]) {
    grid-column: span 8;
  }
  :host([col-span-xl="9"]) {
    grid-column: span 9;
  }
  :host([col-span-xl="10"]) {
    grid-column: span 10;
  }
  :host([col-span-xl="11"]) {
    grid-column: span 11;
  }
  :host([col-span-xl="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 2463px) {
  :host([col-span-xxl="1"]) {
    grid-column: span 1;
  }
  :host([col-span-xxl="2"]) {
    grid-column: span 2;
  }
  :host([col-span-xxl="3"]) {
    grid-column: span 3;
  }
  :host([col-span-xxl="4"]) {
    grid-column: span 4;
  }
  :host([col-span-xxl="5"]) {
    grid-column: span 5;
  }
  :host([col-span-xxl="6"]) {
    grid-column: span 6;
  }
  :host([col-span-xxl="7"]) {
    grid-column: span 7;
  }
  :host([col-span-xxl="8"]) {
    grid-column: span 8;
  }
  :host([col-span-xxl="9"]) {
    grid-column: span 9;
  }
  :host([col-span-xxl="10"]) {
    grid-column: span 10;
  }
  :host([col-span-xxl="11"]) {
    grid-column: span 11;
  }
  :host([col-span-xxl="12"]) {
    grid-column: span 12;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
